import AdminView from "@views/admin.view";

const AdminRoute = () => {
  return <AdminView />;
};

export default AdminRoute;
